import { defineProductDimensions, rcpaPricingVersionDimension, rcpaSelectedDimension } from '@orus.eu/dimensions'

import { rcpaProductVersionDimension } from './rcpa-dimensions.ts'
import { rcpaQuoteDimension } from './rcpa-quote/rcpa-quote-dimension.ts'

export * from './rcpa-dimensions.ts'
export * from './rcpa-subscription-ui.ts'
export * from './rcpa-ui-elements.ts'

export const rcpaDimensionsModule = defineProductDimensions({
  product: 'rcpa',
  family: null,
  selectionDimension: rcpaSelectedDimension,
  productVersionDimension: rcpaProductVersionDimension,
  pricingVersionDimension: rcpaPricingVersionDimension,
  quoteV3Dimension: rcpaQuoteDimension,
})
